document.addEventListener('DOMContentLoaded', () => {
    let toggleBurger = (el: HTMLElement) => {
        const target = document.getElementById(el.dataset.target!)!;
        el.classList.toggle('is-active');
        target.classList.toggle('is-active');
    };

    document.querySelectorAll('.navbar-burger').forEach(el => {
        toggleBurger(el as HTMLElement);
        el.addEventListener('click', () => toggleBurger(el as HTMLElement));
    });

    document.querySelectorAll('.add-basket').forEach(el => {
        el.addEventListener('click', () => {
            const product = document.getElementById((el as HTMLElement).dataset.product! + "-modal")!;
            product.classList.toggle('is-active');
            document.body.parentElement!.classList.add('is-clipped');
        });
    });

    document.querySelectorAll('.modal-card-head .delete').forEach(el => {
        const parentModal = (el as HTMLElement).closest(".modal")!;
        el.addEventListener('click', () => {
            parentModal.classList.remove('is-active');
            document.body.parentElement!.classList.remove('is-clipped');
        });
    });

    document.querySelectorAll('.qty-field').forEach(el => {
        const elIn = el as HTMLInputElement;
        const priceField = document.getElementById(elIn.dataset.target!)! as HTMLInputElement;
        const price = parseFloat(elIn.dataset.priceperunit!);
        const step = parseFloat(elIn.step);

        const onChange = () => {
            if (!isNaN(elIn.valueAsNumber)) {
                const roundedValue = Math.round(Math.min(Math.max(elIn.valueAsNumber, parseFloat(elIn.min)), parseFloat(elIn.max)) / step) * step;
                elIn.valueAsNumber = roundedValue;
                priceField.value = (roundedValue * price).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }) + "€";
            } else {
                priceField.value = "Quantité invalide";
            }
        };

        el.addEventListener('input', () => {
            priceField.value = "";
        });
        el.addEventListener('change', onChange);
        onChange();
    });
});
